import { MappedAttributes } from '../../utils/filterToRender'
import { PriceRange } from '../PriceRange'
import AccordionFilter from './AccordionFilter'
import ToggleFilter from './ToggleFilter'
import * as S from './styled'

interface FilterTypeProps {
  attribute: MappedAttributes
  filterIndex: number
}

const FilterType = ({ attribute, filterIndex }: FilterTypeProps) => {
  const chooseFilter = () => {
    const toggleFilters = [
      'offer.enabled',
      'relevanceFields.novelty',
      'relevanceFields.exclusiveMarkeplace',
      'relevanceFields.exclusiveBrand',
      'relevanceFields.hasStock'
    ]

    if (toggleFilters.includes(attribute)) {
      return <ToggleFilter filterIndex={filterIndex} attribute={attribute} />
    }

    if (attribute === 'price.promotional') {
      return <PriceRange attribute={attribute} filterIndex={filterIndex} />
    }

    return <AccordionFilter attribute={attribute} filterIndex={filterIndex} />
  }

  return <S.Wrapper data-cy={`filter-${attribute}`}>{chooseFilter()}</S.Wrapper>
}

export default FilterType
